export default __webpack_public_path__ + "static/media/dry-cleaning.41607c7b.png";